import Icon from '../components/Icon.vue'

Icon.register({
  'level-up-alt': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M313.6 119.7c14.3 15.4 3.3 40.3-17.6 40.3h-64v328c0 13.3-10.7 24-24 24h-196c-10.7 0-16-12.9-8.5-20.5l56-56c1.9-1.9 5.7-3.5 8.5-3.5h0 84v-272h-64c-21 0-31.8-25-17.6-40.3l104-112c9.5-10.2 25.7-10.2 35.2 0z'
      }
    ]
  }
})
